import posthog from "posthog-js"

export default defineNuxtPlugin({
  name: "posthog",
  setup() {
    const config = useRuntimeConfig()
    const { projectToken, host } = config.public.posthog

    if (!projectToken || !host) {
      if (import.meta.dev) {
        console.warn(
          "[posthog] NUXT_PUBLIC_POSTHOG_PROJECT_TOKEN / NUXT_PUBLIC_POSTHOG_HOST not configured, " +
            "product analytics disabled.",
        )
      }

      return
    }

    const posthogClient = posthog.init(projectToken, {
      api_host: host,
      // Opts into the SDK's dated defaults: `capture_pageview: "history_change"` (SPA pageviews
      // on router navigation) and localhost flagged as internal/test traffic.
      defaults: "2026-01-30",
      debug: import.meta.dev,
      // Sentry owns error tracking and session replay; PostHog is product analytics only.
      // Sentry issues are linked to the PostHog person/session via `posthog.sentryIntegration()`.
      capture_exceptions: false,
      disable_session_recording: true,
    })

    return {
      provide: {
        posthog: posthogClient,
      },
    }
  },
})
